import './styles/main'

import 'lity/dist/lity.js'

import 'magnific-popup/dist/jquery.magnific-popup'
import 'jquery-parallax.js/parallax.js'
import './scripts/scroller-new';

import './scripts/advantages';
import './scripts/forms';
import './scripts/header';
import './scripts/global';
import './scripts/newsroom';
import './scripts/slider';
import './scripts/faq';
import './scripts/countup';
import './scripts/aos';
import './scripts/tabs';
import './scripts/product-details';
import './scripts/problems-solutions';
import './scripts/paginated-list';
import './scripts/quote';
import './scripts/blog';
import './scripts/modal';
import './scripts/hubspot-form';

import './scripts/dropdown-page-nav';
import './scripts/ajax-forms';
import './scripts/build-your-structure';
import './scripts/subscription';
import './scripts/modal-forms';

import './scripts/checkout';

import './scripts/ajax';

$(document).foundation()

$(window).on('changed.zf.mediaquery', function(_, newSize) {
  $('head .mq').text(newSize)
})
